import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../dynamicFormBuilder/FormField'
import data from "../../../assets/apiRoutes.json";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import { CodesLayout } from "../../common/Layouts";
import { RefrencesLayout } from "../../common/Layouts";

function UserDefinedTab(props) {
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var accessToken = props.oidc.user.access_token;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const { userDefinedFormLookupsLoad } = props;

    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    const position = { of: '#accordion-containe2' };
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    const handleCodesFormLoad = useCallback(() => {
       userDefinedFormLookupsLoad(formRefs)
    }, []);
    const handleRefrencesFormLoad = useCallback(() => {

    }, []);

    const handleFieldChange = useCallback((name, value, e) => {
    }, []);



    return (

        <TabPanel className="TabpanelContainer">
            <TabItem title="Codes">
                <FormField
                    currrentUser={currentUser}
                    layoutId='D9F97E52-EDB1-45AC-968E-CCA70C1B5DB8'
                    layoutName='WMTransactionDataEntryUserDefinedTab'
                    defaultFormSchema={CodesLayout}
                    formFields={props.formFields}
                    setformFields={props.setformFields}
                    handleFieldValueChange={handleFieldChange}
                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                    formRefs={formRefs}
                    onFormLoad={handleCodesFormLoad}
                />
            </TabItem>
            <TabItem title="Refrences">
                <FormField
                    currrentUser={currentUser}
                    layoutId='1DFF01CD-DE3A-41A6-B4E0-F150F8225C40'
                    layoutName='WMTransactionDataEntryUserDefinedTab'
                    defaultFormSchema={RefrencesLayout}
                    formFields={props.formFields}
                    setformFields={props.setformFields}
                    handleFieldValueChange={handleFieldChange}
                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                    formRefs={formRefs}
                    onFormLoad={handleRefrencesFormLoad}
                />
            </TabItem>
        </TabPanel>

    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(UserDefinedTab);
